import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DocService {

  private readonly baseUrl: string = 'https://github.com/mowin-tech/mowin-storage/releases/download/';

  /**
   * Download a file
   * @param {string} file - File to download
   */
  public downloadFile(file: string): void {
    window.open(
      `${this.baseUrl}${file}`,
      '_blank'
    );
  }
}